<template>
  <div :class="$style.result">
    <div :class="$style.orderInfo" v-if="orderInfoShow && !resultShow">
      <h2 v-if="!expireTime">确认信息</h2>
      <p>角色名称：{{ cpOrderData.app_role_id }}</p>
      <p>商品名称：{{ cpOrderData.product }}</p>
      <p :class="$style.price">￥{{ cpOrderData.total_fee ? cpOrderData.total_fee / 100 : '' }}</p>
      <p :class="$style.orderSn" v-if="lastOrder.order_sn">订单号：{{ lastOrder.order_sn }}</p>
      
      <Button :class="$style.wechatPay" @click="charge" v-if="!expireTime">微信支付</Button>
      <Button :class="$style.wechatPay" @click="reCharge" v-if="expireTime > 0 && lastOrder.pay_status != 1">继续支付</Button>
      <Button :class="$style.wechatPay" v-if="lastOrder.pay_status == 1">订单已完成</Button>
      <Button :class="[$style.wechatPay, $style.out]" v-if="expireTime < 0 && lastOrder.pay_status != 1">订单超时</Button>
      
      <p v-if="expireTime > 0 && lastOrder.pay_status != 1" :class="$style.timeline">支付剩余时间：{{ timeDisplay }}</p>

    </div>
    <div :class="$style.orderInfo" v-if="!orderInfoShow && orderTimeout">
      <h2>订单已超时</h2>
      <p>请前往游戏内重新下单</p>
    </div>
    <div :class="$style.content" v-if="resultShow">
      <img
        :src="result ? `${$cdnUrl}/success.png` : `${$cdnUrl}/error.png`"
        alt
        :class="$style.state"
      />
      <p :class="result && $style.success">{{ result ? "— 支付成功 —" : "— 支付失败 —" }}</p>
      <p :class="$style.desc">请到游戏内查询具体结果</p>
    </div>
    <img v-if="authVisible" :src="`${$cdnUrl}/auth.jpg`" alt="" :class="$style.auth" @click="authVisible = false">
  </div>
</template>

<script>
import { getSyOrderData, payOrder, officialAccountsPay, checkOrder as checkOrderApi } from "@/api/pay";
import wxSdkInit from "@/libs/wx.init.js";
import { isWeiXin, getCurrentAppkey } from "@/libs/utils";
import { Button } from 'vant';

export default {
  name: "",
  data() {
    return {
      result: 1, // 0.失败 1.成功
      resultShow: false,
      authVisible: false,
      orderInfoShow: true,
      syOrderData: {},
      cpOrderData: {},
      // 已下单订单
      lastOrder: {},
      payType: '',
      expireTime: 0,  // 剩余秒数
      timeDisplay: '',  // 格式化后的倒计时显示
      countdownInterval: null,  // 倒计时的定时器
      chargeCache: false,
      orderTimeout: false,
    };
  },
  computed: {
    // 获取微信授权 appId，优先从 URL 参数获取
    wxAppId() {
      return this.$route.query.wx_app_id || this.$route.meta.auth;
    },
    // 根据域名判断使用哪个 appkey，悦玩域名使用 ywAppkey
    currentAppkey() {
      return getCurrentAppkey(this.$route);
    }
  },
  created() {
    document.title = "支付";
    const is_snapshotuser = localStorage.getItem("is_snapshotuser")
    if (is_snapshotuser == 1) this.authVisible = true;
  },
  mounted() {
    if (!this.$route.query.token) {
      return;
    }
    if (isWeiXin()) {
      wxSdkInit(this.currentAppkey, this.wxAppId);
      this.payType = '52';
    } else {
      this.payType = '26';
    }
    this.getOrderData();
  },
  methods: {
    async getOrderData() {
      const { token } = this.$route.query;
      try {
        const r = await getSyOrderData({ token });
        this.syOrderData = JSON.parse(r.content.extra_data);
        this.cpOrderData = JSON.parse(this.syOrderData.order_data);
        
        this.lastOrder = r.content.order || {};
        if (r.content.expire_time && r.content.expire_time > 0) {
          // 保存倒计时秒数
          this.expireTime = parseInt(r.content.expire_time / 1000);
          this.startCountdown();
        }
      } catch (e) {
        console.log(e, e.ret == 697)
        if (e.ret && e.ret == 697) {
          this.orderInfoShow = false;
          this.orderTimeout = true;
          return;
        }
        console.log(JSON.stringify(e));
        this.$toast("订单信息获取失败");
      }
    },
    startCountdown() {
      // 每秒更新一次倒计时
      this.countdownInterval = setInterval(() => {
        if (this.expireTime > 0) {
          this.expireTime--;  // 减少剩余时间
          this.updateTimeDisplay();  // 更新倒计时显示
        } else {
          clearInterval(this.countdownInterval);  // 时间到，停止倒计时
        }
      }, 1000);
    },
    updateTimeDisplay() {
      const hours = Math.floor(this.expireTime / 3600);
      const minutes = Math.floor((this.expireTime % 3600) / 60);
      const seconds = this.expireTime % 60;

      // 格式化为 HH:mm:ss
      this.timeDisplay = `${this.padZero(hours)}:${this.padZero(minutes)}:${this.padZero(seconds)}`;
    },
    padZero(num) {
      return num < 10 ? `0${num}` : `${num}`;
    },
    async charge() {
      if (this.chargeCache) {
        this.$toast("请勿重复支付，如未支付成功请尝试刷新页面");
        return;
      }
      this.chargeCache = true;
      const payRes = await payOrder({
        ...this.syOrderData,
        pay_type: this.payType,
      });
      if (isWeiXin()) {
        this.officialAccountsPay(payRes.content.order_sn)
      } else {
        let host = location.host === 'webpre.hzwxbz999.cn' || process.env.VUE_APP_IS_TEST ? "https://h5.hzwxbz999.cn" : "https://h5.hzwxbz3.cn";
        if (location.host === 'wap.yuwanc.com' || location.host === 'wap.w2you.com' || location.host === 'wap.bgyxy.com') {
          host = "https://h5.yuwanc.com";
        }
        if (location.host === 'wap-pre.yuwanc.com') {
          host = "https://h5-pre.yuwanc.com";
        }
        let url = host +
          '/pay/pay?order_sn=' +
          payRes.content.order_sn +
          '&os=ios' +
          '&access_token=' +
          this.syOrderData.access_token +
          '&uid=' +
          this.syOrderData.uid +
          '&jh_app_id=' +
          this.syOrderData.jh_app_id +
          '&sdk_version=' +
          this.syOrderData.sdk_version +
          '&pay_type=' +
          this.payType;
        location.href = url;
      }
    },
    async officialAccountsPay(order_sn) {
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      const r = await officialAccountsPay({
        appkey: this.currentAppkey,
        order_sn: order_sn,
        wx_app_id: this.wxAppId,
        open_id: userInfo.open_id,
      });
        const { nonceStr, paySign, timeStamp, signType } = r.content;
        wx.chooseWXPay({
          timestamp: timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr, // 支付签名随机串，不长于 32 位
          package: r.content.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign, // 支付签名
          success: (res) => {
            this.checkOrder(order_sn);
          },
          fail: (err) => {
            this.checkOrder(order_sn);
          },
          cancel: () => {
            this.checkOrder(order_sn);
          },
        });
    },
    reCharge() {
      if (isWeiXin() && this.lastOrder.pay_type == '26') {
        this.$toast("请在浏览器打开链接完成支付，或游戏内重新生成订单");
        return;
      } 
      
      if (!isWeiXin() && this.lastOrder.pay_type == '52') {
        this.$toast("请在微信扫码完成支付，或游戏内重新生成订单");
        return;
      }

      if (isWeiXin()) {
        this.officialAccountsPay(this.lastOrder.order_sn);
      } else {
        const host = location.host === 'webpre.hzwxbz999.cn' || process.env.VUE_APP_IS_TEST ? "https://h5.hzwxbz999.cn" : "https://h5.hzwxbz3.cn";
        let url = host +
          '/pay/pay?order_sn=' +
          this.lastOrder.order_sn +
          '&os=ios' +
          '&access_token=' +
          this.syOrderData.access_token +
          '&uid=' +
          this.syOrderData.uid +
          '&jh_app_id=' +
          this.syOrderData.jh_app_id +
          '&sdk_version=' +
          this.syOrderData.sdk_version +
          '&pay_type=' +
          this.lastOrder.pay_type;
        location.href = url;
      }
    },
    async checkOrder(order_sn) {
      const r = await checkOrderApi({ order_sn });
      const { pay_status } = r.content;
      if (pay_status == 1) {
        this.resultShow = true;
        this.result = 1;
        this.$toast("支付成功，实际支付结果请以游戏内为准");
      } else {
        this.$toast("支付失败，实际支付结果请以游戏内为准");
        setTimeout(() => {
          location.reload();
        }, 2000);
      }
    }
  },
  beforeDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);  // 清除倒计时
    }
  },
  components: {
    Button
  }
};
</script>

<style lang="scss" module>
.result {
  height: 100%;
  background: #F6F6F6;
  .orderInfo {
    text-align: center;
    padding-top: 22px;
    > h2 {
      font-size: 15px;
      font-weight: 500;
      text-align: center;
      color: #030303;
      line-height: 31px;
    }
    p {
      font-size: 12px;
      text-align: center;
      color: #474747;
      line-height: 31.5px;
    }
    .price {
      font-size: 31px;
      font-weight: 500;
      color: #000000;
      text-align: center;
      line-height: 23px;
      margin: 32px 0 50px;
    }
    .orderSn {
      width: 246px;
      margin: auto;
      height: 39px;
      background: #ffffff;
      border-radius: 8px;
      font-size: 12px;
      text-align: center;
      color: #474747;
      line-height: 40px;
      margin-bottom: 10px;
    }
    .timeline {
      text-align: center;
      color: #9e9e9e;
    }
    .wechatPay {
      width: 216.5px;
      height: 46px;
      background: #05b365;
      border-radius: 23px;
      color: #FFFFFF;
      font-size: 18px;
      &.out {
        background: #9e9e9e;
      }
    }
  }
  .content {
    padding: 40px 0 40px;
    img {
      display: block;
      margin: auto;
    }
    .state {
      width: 50px;
      height: 50px;
      margin-bottom: 20px;
    }
    .success {
      color: #000000;
    }
    p {
      color: #000000;
      font-size: 28px;
      letter-spacing: 2px;
      text-align: center;
    }
    .contact,
    .back {
      width: 180px;
    }
    .contact {
      margin-top: 36px;
      margin-bottom: 19px;
    }
    .desc {
      font-size: 15px;
      margin: 18px 0 25px;
    }
  }
  .auth {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    opacity: 0.6;
  }
}
</style>
